module.exports = __webpack_public_path__ + "assets/img/companyicon1.fcb4d296.jpg";